
<div class="app-notification-panel m-2" style="z-index: 9999999;">
  <div *ngFor="let event of events.slice().reverse()" class="notification-alert p-1 m-1 d-flex justify-content-between"
    [ngClass]="'alert-' + (event.type=='error'?'danger':event.type)">
    <div  class="m-sm-1 p-1">
        {{event.message|shorten:140:'...'}}
      </div>
      <div class="">
        <i class="fa fa-times" role="button" (click)="remove(event)"></i>
      </div>
    </div>
</div>